<template>
    <v-container>
      
    <v-btn router to="/user/creation"  color="#0a42da"
         class="text-none ms-1 text-white" >  
         <v-icon
        
        class="me-2"
        
      >
      mdi-plus</v-icon>Nouveau Utilisateur</v-btn>
<v-data-table
style="border-color: #0b60bb;border-style: solid;border-width: 0.1px;"
:headers="headers"
:items="listData"
no-data-text="Pas de données disponible"
      items-per-page-text="Nombre d'elements par page"
>
<template v-slot:[`item.actions`]="{ item,index }">
    
      <v-btn flat route :to="'/user/update/'+item.id">
      <v-icon
        size="small"
        class="me-2"
        
      >
        mdi-pencil
      </v-icon>
      </v-btn>
      <v-btn  flat>
      <v-icon
        size="small"
        @click="deleteItem(item,index)"
      >
        mdi-delete
      </v-icon>
      </v-btn>
    </template>
    
</v-data-table>
</v-container>
</template>
<script>
import http from '../../http.js'

export default {
    data: () => ({
      
    headers:[{"title":"Nom","key":"nom"},{"title":"Prénom","key":"prenom"},{"title":"Email","key":"email"},{"title":"Actif","key":"active"},{ title: 'Actions', key: 'actions', sortable: false }],
    creation:false,
    loading: false,
     data:{datePrise:new Date().toISOString().substring(0,new Date().toISOString().indexOf("."))},
     listData:[]

    })
    ,mounted(){
        this.list()
    },
    methods:{
    list(){
        http
            .get('/api/utilisateur')
            .then(response => { this.listData = response.data; });
      },
      async deleteItem(item,index){      
          if(confirm('Etes vous sur de la suppresion de '+item.nom+" "+item.prenom +' ?')){
            await http.delete("/api/utilisateur/"+item.id)            
            this.listdata.splice(index, 1);
      }
    }
  }
}
</script>